import { DropdownIcon } from "app/components/Icons";
import EffortEntryRow from "app/containers/Features/components/EffortActual/EffortEntryRow";
import { getMembersByIds } from "app/containers/Features/components/MemberSelection/helper";
import { selectProjectMemberList } from "app/containers/Features/components/MemberSelection/redux/selector";
import UserAvatar from "app/containers/Features/components/TimeTracker/UserAvatar";
import { IEffortActual } from "app/containers/Features/containers/Ticket/types";
import { ISelectedTicketDetails } from "app/containers/Features/containers/TimeSheet/types";
import { formatEffortShorthand } from "app/containers/Features/helper";
import clsx from "clsx";
import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";

export interface MemberGroup {
  memberId: string;
  entries: IEffortActual[];
  totalHours: number;
  totalMinutes: number;
}

const MemberEntryGroup = ({
  group,
  selectedTicketDetails,
}: {
  group: MemberGroup;
  selectedTicketDetails: ISelectedTicketDetails;
}) => {
  // Global States
  const projectMemberList = useSelector(selectProjectMemberList);

  // Local States
  const [enableRowData, setEnableRowData] = useState(false);

  // Variables
  const member = useMemo(() => {
    return getMembersByIds(projectMemberList, group.memberId)[0];
  }, [projectMemberList, group.memberId]);

  return (
    <>
      <div
        className="p-1.5 cursor-pointer"
        onClick={() => setEnableRowData((prev) => !prev)}
      >
        <div className="p-2.5 flex items-center justify-between gap-1 group hover:bg-gray-400 rounded">
          <div className="flex items-center gap-1.5">
            <DropdownIcon
              className={clsx("transition-transform -rotate-90", {
                "rotate-0": enableRowData,
              })}
            />
            <UserAvatar
              avatar={member?.avatar}
              fullName={member?.name || "Unknown"}
              containerClassName="!rounded-[0px] !p-0 bg-white w-fit border-0 group-hover:bg-gray-400"
            />
          </div>

          <p className="text-sm font-medium leading-none">
            {formatEffortShorthand(group.totalHours, group.totalMinutes)}
          </p>
        </div>
      </div>

      {enableRowData ? (
        <div className="flex flex-col gap-1.5 pl-6 pr-4 max-h-28 overflow-y-auto">
          {group.entries.map((entry) => (
            <EffortEntryRow
              key={entry._id}
              entry={entry}
              selectedTicketDetails={selectedTicketDetails}
            />
          ))}
        </div>
      ) : null}
    </>
  );
};

export default MemberEntryGroup;
